import React from 'react';
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

export default function StatusIndicator({ payment_status, purchase_type = null }) {
  const { t } = useTranslation();

  const status_html = (status, type) => {
    if(status === 'pending') {
      // Show "Pending" for offline, "Invoice" for invoice-based subscriptions
      const label = type === 'offline' ? t("Pending") : t("Invoice");
      return (<div className={styles.status_invoice}>{label}</div>);
    } else if (status === 'paid') {
      return (<div className={styles.status_paid}>{t("Paid")}</div>);
    } else if (status === 'cancelled') {
        return (<div className={styles.status_failed}>{t("Cancelled")}</div>);
    } else if (status === 'scheduled') {
      // CN-2832: signed up before a custom start date; nothing charged yet.
      return (<div className={styles.status_scheduled}>{t("Scheduled")}</div>);
    } else if (status === 'past_due') {
      return (<div className={styles.status_failed}>{t("Past Due")}</div>);
    } else {
      return (<div className={styles.status_failed}>{t("Failed")}</div>);
    }
  };
  return (
    status_html(payment_status, purchase_type)
  );
}
